<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a>Money over Mastery, Family over Freedom</h1>
<p class="subtitle">Slavery in the Antebellum Upper South</p>
<p class="imagea"><img alt="image" src="images/f0iii-01.jpg"/></p>
<p class="author">Calvin Schermerhorn</p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?d588d86a